<dx-popup
    [minWidth]="isSmallScreen ? popupWidth : undefined"
    [minHeight]="isSmallScreen ? popupHeight : undefined"
    [maxWidth]="!isSmallScreen ? popupWidth : undefined"
    [maxHeight]="!isSmallScreen ? popupHeight : undefined"
    [title]="popupTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [showCloseButton]="true"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'" class="cb-batch-details-content">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <dx-form class="batch-form-data">
                    <dxi-item>
                        <dxo-label text="Batch"></dxo-label>
                        <div *dxTemplate>{{ batchDetailResult?.title }}</div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Batch Type"></dxo-label>
                        <div *dxTemplate>{{ batchDetailResult?.type }}</div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate>{{ batchDetailResult?.postDate | date: dateFormat }}</div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Total Count"></dxo-label>
                        <div *dxTemplate>{{ batchDetailResult?.totalCount }}</div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Total Amount"></dxo-label>
                        <div *dxTemplate>{{ batchDetailResult?.totalAmount | ccCurrency }}</div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <cc-data-grid-features
                        [stateConfig]="{ storageKey: 'CB_CM_BATCH_DETAIL_GRID' }"
                        [dataSource]="batchDetailResult?.items"
                    >
                        <dx-data-grid
                            width="100%"
                            height="100%"
                            class="cc-vertical-center-cell-data-grid"
                            [dataSource]="batchDetailResult?.items"
                        >
                            <dxo-summary [calculateCustomSummary]="calculateCustomSummary">
                                <dxi-total-item
                                    name="amount"
                                    showInColumn="amount"
                                    summaryType="custom"
                                    displayFormat="Total: {0}"
                                    [valueFormat]="currencyFormat"
                                ></dxi-total-item>

                                <dxi-group-item
                                    column="batchID"
                                    summaryType="count"
                                    displayFormat="Count = {0}"
                                ></dxi-group-item>
                            </dxo-summary>
                            <dxi-column
                                dataField="postDate"
                                dataType="date"
                                caption="Post Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="docDate"
                                dataType="date"
                                caption="Doc Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="docNumber"
                                dataType="string"
                                caption="Document No"
                                cellTemplate="docNumberCellTemplate"
                            ></dxi-column>
                            <dxi-column dataField="description" dataType="string" caption="Description"></dxi-column>
                            <dxi-column
                                dataField="vendorCustomerName"
                                dataType="string"
                                caption="Customer / Vendor"
                                cellTemplate="customerVendorLinkCellTemplate"
                            ></dxi-column>
                            <dxi-column dataField="sourceType" dataType="string" caption="Source Type"></dxi-column>
                            <dxi-column
                                dataField="amount"
                                dataType="number"
                                caption="Amount"
                                [format]="currencyFormat"
                                cellTemplate="hyperlinkTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataField="vendorCustomerCode"
                                dataType="string"
                                caption="Customer / Vendor Code"
                                cellTemplate="customerVendorLinkCellTemplate"
                            ></dxi-column>

                            <div *dxTemplate="let row of 'customerVendorLinkCellTemplate'">
                                <div *ngIf="batchDetailResult?.type === 'AR'">
                                    <app-hyperlink-creator
                                        [displayText]="row.value"
                                        (onLinkClick)="onVendorCustomerClick(row.data)"
                                        mode="hyperlinkOnly"
                                    ></app-hyperlink-creator>
                                </div>
                                <span *ngIf="batchDetailResult?.type !== 'AR'">{{ row.value }}</span>
                            </div>

                            <div *dxTemplate="let row of 'hyperlinkTemplate'">
                                <app-hyperlink-creator
                                    *ngIf="hasHyperlink(row.data)"
                                    cssClass="cc-clickable-link cc-hyper-link"
                                    [displayText]="currencyFormatter(row.value)"
                                    (onLinkClick)="onAmountClick(row.data)"
                                ></app-hyperlink-creator>
                                <span *ngIf="!hasHyperlink(row.data)">
                                    {{ currencyFormatter(row.value) }}
                                </span>
                            </div>

                            <div *dxTemplate="let row of 'docNumberCellTemplate'">
                                <app-hyperlink-creator
                                    *ngIf="hasHyperlink(row.data)"
                                    cssClass="cc-clickable-link cc-hyper-link"
                                    [displayText]="row.value"
                                    (onLinkClick)="onAmountClick(row.data)"
                                ></app-hyperlink-creator>
                                <span *ngIf="!hasHyperlink(row.data)">
                                    {{ row.value }}
                                </span>
                            </div>
                        </dx-data-grid>
                    </cc-data-grid-features>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="button-container">
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    [icon]="iconClose"
                                    (onClick)="onHidden()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: 'body' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
